module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e07mD"))).then(() => parcelRequire('5erN3'));